<template>

    <div>

        <loading-indicator :loading="isLoading"></loading-indicator>

        <v-client-table v-if="!isLoading" ref="pimCampaignsTable" name="pimCampaignsTable"
            class="tbl-campaigns noFirstColumn" :data="filteredCampaigns" :columns="tblColumns"
            :options="table.tblOptions">
            <!-- before table: FILTER OPTIONS -->
            <template slot="beforeTable">

                <div v-if="!embeddedView" class="box" style="padding: 15px">
                    <fieldset :class="['filterBox', { active: showFilterBox }]">
                        <legend @click="showFilterBox = !showFilterBox">
                            Filter
                            <template v-if="!showFilterBox">+</template><template v-else>-</template>
                        </legend>

                        <div class="filterWrapper" v-if="showFilterBox">
                            <filter-element v-for="filter in filters" :filter="filter"
                                :key="filter.queryName"></filter-element>
                        </div>
                    </fieldset>

                    <div class="columns is-marginless filters">

                        <!-- SUCHE -->
                        <div class="column">
                            <div class="control has-icon search" style="min-width: 150px">
                                <input class="input" type="text" v-model.trim="filters.filterSearch.value"
                                    placeholder="Suchbegriff" @keyup.enter="filter()" />
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </div>
                        </div>

                        <div class="column is-narrow">
                            <span class="button is-success filter" @click="filter()">
                                anwenden
                                <span class="icon is-small success" style="margin: 0 !important">
                                    <i class="icon-ak-filter"></i>
                                </span>
                            </span>

                            <span :class="[
                                isFilterActive ? 'is-blue' : 'is-disabled',
                                'button reset-filter',
                            ]" @click="resetFilters()" style="margin: 0 0 0 5px">
                                <span class="icon is-small">
                                    <i class="icon-ak-reset"></i>
                                </span>
                            </span>
                        </div>

                    </div>

                </div>

            </template>

            <template slot="type" slot-scope="props">
                <template v-if="
                    props.row.type != null &&
                    typeof props.row.type.name != 'undefined'
                ">
                    <lang :labelKey="'PIM-CAMPAIGNS-TYPE-' + props.row.type.name"></lang>
                </template>
            </template>

            <template slot="voucherCode" slot-scope="props">
                <!-- {{ props.row.voucherCode != null ? 'ja' : 'nein' }} -->
                {{ props.row.voucherCode != null ? props.row.voucherCode : "-" }}
            </template>

            <template slot="validFrom" slot-scope="props">
                <template v-if="props.row.validFrom">
                    {{ formatDate2(props.row.validFrom, false) }}
                </template>
            </template>

            <template slot="validTo" slot-scope="props">
                <template v-if="props.row.validTo">
                    {{ formatDate2(props.row.validTo, false) }}
                </template>
            </template>

            <template slot="_statusComputed" slot-scope="props">

                <template v-if="isArchive === true">
                    <tag size="small">
                        <lang labelKey="PIM-CAMPAIGNS-STATUS-ARCHIVED"></lang>
                    </tag>
                </template>

                <template v-else>

                    <template v-if="props.row._statusComputed == 'DRAFT'">
                        <tag size="small">
                            <lang :labelKey="'PIM-CAMPAIGNS-STATUS-' + props.row._statusComputed
                                "></lang>
                        </tag>
                    </template>

                    <template v-else>
                        <tag type="success" size="small">
                            <lang :labelKey="'PIM-CAMPAIGNS-STATUS-' + props.row._statusComputed
                                "></lang>
                        </tag>
                    </template>
                </template>
            </template>

            <template slot="_source" slot-scope="props">
                <lang :labelKey="'PIM-CAMPAIGNS-SOURCE-' + props.row._source" />
            </template>

            <template slot="takeOver" slot-scope="props">
                <template v-if="
                    activeUser.site != null &&
                    props.row.site == null &&
                    props.row.parent == null
                ">
                    <span :class="[
                        'button is-small is-blue',
                        {
                            'is-loading':
                                typeof props.row.isAccepting != 'undefined' &&
                                props.row.isAccepting == true,
                        },
                    ]" @click.prevent="campaignTakeOver(props.row)" title="Diese Aktion übernehmen">
                        <span class="icon is-small">
                            <i class="icon-ak-freigaben2"></i>
                        </span>
                    </span>
                </template>
            </template>

            <template slot="actions" slot-scope="props">

                <!-- own action -->
                <template v-if="
                    activeUser.site == null ||
                    (activeUser.site != null &&
                        props.row.site != null &&
                        activeUser.site.id == props.row.site &&
                        props.row.parent == null)">
                    <span class="button is-small" @click.prevent="campaignEdit(props.row)" title="Aktion bearbeiten">
                        <span class="icon is-small">
                            <i class="icon-ak-bearbeiten"></i>
                        </span>
                    </span>

                    <pop-confirm class="button is-small"
                        content="Sind Sie sicher, dass Sie diese Aktion entfernen möchten?" icon="question-circle-o"
                        :on-ok="function () {
                            campaignDelete(props.row.id);
                        }
                            " cancel-text="nein" v-if="!embeddedView">
                        <span class="icon is-small" title="Aktion löschen">
                            <i class="icon-ak-entfernen"></i>
                        </span>
                    </pop-confirm>

                    <span :class="[
                        'button is-small',
                        {
                            'is-loading':
                                typeof props.row.isLoadingPreview != 'undefined' &&
                                props.row.isLoadingPreview == true,
                        },
                    ]" @click.prevent="campaignView(props.row)" title="Preview Aktion">
                        <span class="icon is-small">
                            <i class="icon-ak-preview"></i>
                        </span>
                    </span>
                </template>

                <!-- copied and published -->
                <template v-else-if="
                    activeUser.site != null &&
                    props.row.site != null &&
                    activeUser.site.id == props.row.site &&
                    props.row.parent != null">

                    <pop-confirm class="button is-small"
                        content="Sind Sie sicher, dass Sie diese Aktion entfernen möchten?" icon="question-circle-o"
                        :on-ok="function () {
                            campaignDelete(props.row.id);
                        }
                            " cancel-text="nein" v-if="!embeddedView">
                        <span class="icon is-small" title="Aktion löschen">
                            <i class="icon-ak-entfernen"></i>
                        </span>
                    </pop-confirm>

                    <span v-if="!embeddedView" :class="[
                        'button is-small',
                        {
                            'is-loading':
                                typeof props.row.isLoadingPreview != 'undefined' &&
                                props.row.isLoadingPreview == true,
                        },
                    ]" @click.prevent="campaignView(props.row)" title="Preview Aktion">
                        <span class="icon is-small">
                            <i class="icon-ak-preview"></i>
                        </span>
                    </span>
                </template>

                <!-- template -->
                <template v-else-if="props.row.parent == null">

                    <span :class="[
                        'button is-small',
                        {
                            'is-loading':
                                typeof props.row.isLoadingPreview != 'undefined' &&
                                props.row.isLoadingPreview == true,
                        },
                    ]" @click.prevent="campaignView(props.row)" title="Preview Aktion">
                        <span class="icon is-small">
                            <i class="icon-ak-preview"></i>
                        </span>
                    </span>
                </template>
            </template>

        </v-client-table>

        <!-- MODAL -->
        <modal :title="modal.title" transition="fadeDown" :is-show="showModal" :backdrop-closable="false"
            :show-footer="true" @close="closeModal" :class="['vcenter', modal.class]">

            <template v-if="modal.type == 'campaignView' && campaignViewIsLoaded">
                <!-- <h1><lang :labelKey="'PIM-CAMPAIGNS-TYPE-'+campaignSelected.type.name" /></h1> -->

                <div style="position: absolute; right: 20px; top: 20px">

                    <template v-if="isArchive">

                        <tag size="small">
                            <lang labelKey="PIM-CAMPAIGNS-STATUS-ARCHIVED"></lang>
                        </tag>

                    </template>

                    <template v-else>

                        <template v-if="campaignSelected._statusComputed == 'DRAFT'">
                            <tag size="small">
                                <lang :labelKey="'PIM-CAMPAIGNS-STATUS-' + campaignSelected._statusComputed
                                    "></lang>
                            </tag>
                        </template>
    
                        <template v-else>
                            <tag type="success" size="small">
                                <lang :labelKey="'PIM-CAMPAIGNS-STATUS-' + campaignSelected._statusComputed
                                    "></lang>
                            </tag>
                        </template>

                    </template>
                </div>

                <div class="section">
                    <label>Quelle</label>
                    <p>
                        <lang :labelKey="determineSource(campaignSelected)" />
                    </p>
                </div>

                <div class="section" v-if="campaignSelected.category != null">
                    <label>Kategorie</label>{{ campaignSelected.category.name }}
                </div>

                <div class="section">
                    <label>Beschreibung</label>
                    <p>{{ campaignSelected.description }}</p>
                </div>

                <div class="section">
                    <label>Gültigkeit</label>

                    Beginn:
                    <template v-if="campaignSelected.validFrom != null">
                        {{ formatDate2(campaignSelected.validFrom) }} Uhr
                    </template>
                    <template v-else>-</template>
                    <br />

                    Ende:
                    <template v-if="campaignSelected.validTo != null">
                        {{ formatDate2(campaignSelected.validTo) }} Uhr
                    </template>
                    <template v-else> - </template>
                </div>

                <!--
            <div class="section">
                <label>Status</label><lang :labelKey="'PIM-CAMPAIGNS-STATUS-'+campaignSelected.status.name" />
            </div>
            -->

                <div class="divider"></div>

                <!-- VOUCHER -->
                <div class="section" v-if="campaignSelected.type.name != 'AEP'">
                    <label>Gutschein</label>
                    <!-- {{ campaignSelected.voucherCode == null ? 'nein' : campaignSelected.voucherCode }} -->
                    <template v-if="campaignSelected.voucherCode == null">
                        nein
                    </template>
                    <template v-else>
                        {{ campaignSelected.voucherCode
                        }}<template v-if="campaignSelected.isActivatable">
                            [CHECKBOX]</template>
                    </template>
                </div>

                <!-- AEP -->
                <div class="section" v-if="campaignSelected.type.name == 'AEP'">
                    <label>AEP Zuschlag</label>
                    {{ campaignSelected.discountPercent }}%
                </div>

                <!-- DISCOUNT SETTINGS -->
                <template v-if="
                    campaignSelected.type.name == 'DISCOUNT' ||
                    campaignSelected.type.name == 'CART_DISCOUNT' ||
                    campaignSelected.type.name == 'LOYALTY_POINTS' 
                ">
                    <div class="divider"></div>

                    <div class="section">

                        
                        <label>Discount-Typ</label>
                        <template v-if="campaignSelected.type.name != 'LOYALTY_POINTS'">
                        {{
                            campaignSelected.discountPercent != null &&
                                campaignSelected.discountPercent != ""
                                ? "Prozent (" + campaignSelected.discountPercent + "%)"
                                : "Wert (EUR " + formatPoint2Comma(campaignSelected.discount) + ")"
                        }}
                        </template> 
                        <template v-else>
                            {{  formatPoint2Comma(campaignSelected.discount) }} Bonuspunkte
                        </template>
                    </div>

                    <template v-if="campaignSelected.type.name == 'CART_DISCOUNT'">
                        <div class="section">
                            <label>
                                <lang labelKey="PIM-CAMPAIGN-MINIMUM_ORDER_VALUE" />
                            </label>
                            {{
                                campaignSelected.minTotal == null
                                    ? ""
                                    : "EUR " + campaignSelected.minTotal
                            }}
                        </div>
                    </template>
                </template>

                <!-- PRODUCT SETTINGS -->
                <template v-if="
                    campaignSelected.type.name == 'OFFER_PRICE' ||
                    campaignSelected.type.name == 'DISCOUNT' ||
                    campaignSelected.type.name == 'LOYALTY_POINTS'
                ">
                    <div class="divider"></div>

                    <div class="section">
                        <label>
                            <lang labelKey="PIM-CAMPAIGN-PRODUCTS" />
                        </label>

                        <ul class="pimProducts" v-if="campaignSelected.products.length > 0">
                            <li v-for="p in campaignSelected.products.filter((p) => p.pimProduct != null)" :key="p.id">

                                <template v-if="p.pimProduct.name">{{ p.pimProduct.name }}</template><br>
                                <span class="subline">
                                    <template v-if="p.pimProduct.extRef">PZN: {{ p.pimProduct.extRef }} | {{ campaignSelected.type.name == 'LOYALTY_POINTS' ? 'Bonuspunkte: ' : 'EUR' }}</template>
                                    {{ p.offerPrice != null ? formatPoint2Comma(p.offerPrice) :
                                    formatPoint2Comma(p.pimProduct.price) }}
                                </span>

                            </li>
                        </ul>
                        <template v-else> - </template>
                    </div>

                    <template v-if="campaignSelected.type.name == 'DISCOUNT' || campaignSelected.type.name == 'LOYALTY_POINTS'">
                        <div class="section">
                            <label>
                                <lang labelKey="PIM-CAMPAIGN-PRODUCT_CATEGORIES" />
                            </label>
                            <span>{{
                                campaignSelected._productCategories != null
                                    ? campaignSelected._productCategories
                                : "-"
                                }}</span>
                        </div>

                        <div class="section">
                            <label>
                                <lang labelKey="PIM-CAMPAIGN-PRODUCT_GROUPS" />
                            </label>
                            <span>{{
                                campaignSelected._productGroups != null
                                    ? campaignSelected._productGroups
                                : "-"
                                }}</span>
                        </div>

                        <div class="section">
                            <label>
                                <lang labelKey="PIM-CAMPAIGN-BRANDS" />
                            </label>
                            <span>{{
                                campaignSelected._brands != null
                                    ? campaignSelected._brands
                                : "-"
                                }}</span>
                        </div>
                    </template>
                </template>

                <div class="divider"></div>

                <div class="section">
                    <label>
                        <lang labelKey="PIM-CAMPAIGN-CUSTOMER_GROUPS" />
                    </label>
                    <span>{{
                        campaignSelected._customerGroups != null
                            ? campaignSelected._customerGroups
                        : "-"
                        }}</span>
                </div>

                <template v-if="campaignSelected.type.name != 'AEP'">
                    <div class="divider"></div>

                    <div class="section">
                        <label>Kombinierbar</label>{{ campaignSelected.isNotCombinable ? "nein" : "ja" }}
                    </div>
                </template>

                <template slot="footer">
                    <a class="button" @click="closeModal">Schließen</a>
                </template>
            </template>
        </modal>
    </div>
</template>



<script>
import Vue from "vue";

import { ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable, {}, false, "bulma");

import filterElement from "../incl-filterElement";
import Multiselect from "vue-multiselect";
import { compareDates } from "./utils";

export default {
    name: "pimCampaigns",

    components: {
        filterElement,
        Multiselect
    },

    props: {
        embeddedView: {
            type: Boolean,
            default: false
        },
        isArchive: {
            type: Boolean,
            default: false
        },
        openNewCampaignModal: {
            type: Boolean,
            default: false,
        },
        givenSiteId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            useErpOffers: false,

            isLoading: false,
            isRefetching: false,
            campaignViewIsLoaded: false,

            allMarked: false,
            markedRows: [],

            campaigns: [],
            campaignSelected: null,

            site: null,
            modal: {
                isSaving: false,
                isLoading: false,
                title: "",
                type: null,
                class: "",
            },
            showFilterBox: true,

            filters: {
                filterSearch: {
                    type: "search",
                    queryName: "search",
                    isActive: false,
                    value: null,
                    show: false,
                },

                filterType: {
                    type: "dropdown",
                    queryName: "type",
                    selectFieldName: "displayName",
                    isActive: false,
                    label: "CAMPAIGN_TYPE",
                    selectOptions: null,
                    options: null,
                },

                filterVoucher: {
                    type: "default",
                    queryName: "voucher",
                    isActive: false,
                    options: [
                        {
                            displayName: "Gutschein",
                            name: "VOUCHER_ACTIVE",
                            selected: false,
                            id: 0,
                        },
                        {
                            displayName: "allg. Aktion",
                            name: "VOUCHER_INACTIVE",
                            selected: false,
                            id: 1,
                        },
                    ],
                },

                filterSource: {
                    show: true,
                    type: "default",
                    queryName: "source",
                    isActive: false,
                    options: [
                        {
                            displayName: "HerbaChemosan",
                            name: "EXTERN",
                            selected: false,
                            id: 0,
                        },
                        {
                            displayName: "Eigene Aktion",
                            name: "INTERN",
                            selected: false,
                            id: 1,
                        },
                    ],
                },

                filterStatus: {
                    show: true,
                    type: "default",
                    queryName: "status",
                    isActive: false,
                    options: [
                        { displayName: "Entwurf", name: "DRAFT", selected: false, id: 0 },
                        {
                            displayName: "Veröffentlicht",
                            name: "PUBLISHED",
                            selected: false,
                            id: 1,
                        },
                    ],
                },

            },

            table: {
                tblOptions: {
                    uniqueKey: "id",
                    saveState: true,
                    perPage: 25,

                    orderBy: {
                        ascending: false,
                        column: "updated",
                    },

                    sortIcon: {
                        base: "fa",
                        up: "fa-sort-up",
                        down: "fa-sort-down",
                        is: "fa-sort",
                    },

                    headings: {
                        type(h) {
                            return <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-TYPE"></lang>;
                        },
                        description(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-DESCRIPTION"></lang>
                            );
                        },
                        validFrom(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-VALID_FROM"></lang>
                            );
                        },
                        validTo(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-VALID_TO"></lang>
                            );
                        },
                        _source(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-SOURCE"></lang>
                            );
                        },
                        _statusComputed(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-STATUS"></lang>
                            );
                        },
                        voucherCode(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-VOUCHER"></lang>
                            );
                        },
                        productCount(h) {
                            return (
                                <lang labelKey="PIM-CAMPAIGNS-TABLE_HEADING-PRODUCTS"></lang>
                            );
                        },
                        takeOver(h) {
                            return "";
                        },
                        actions(h) {
                            return "";
                        },
                    },

                    sortable: [
                        "_source",
                        "_statusComputed",
                        "validFrom",
                        "validTo",
                        "productCount",
                        "voucherCode",
                    ],

                    texts: {
                        first: "Anfang",
                        last: "Ende",
                        filter: "Filter Ergebnisse:",
                        filterPlaceholder: "Suche",
                        limit: "Einträge pro Seite",
                        noResults: "keine passenden Einträge gefunden",
                        count:
                            "{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag",
                        loading: "Lade Daten ...",
                    },

                    pagination: {
                        dropdown: false,
                        chunk: 5,
                        edge: false,
                    },

                    skin: "table is-striped is-hoverable is-fullwidth",

                    // custom filter functions
                    customFilters: [
                        {
                            name: "search",
                            callback(row, string) {
                                if (string == null || string.trim() == "") {
                                    return true;
                                }

                                string = string.toLowerCase();

                                return (
                                    row.description.toLowerCase().indexOf(string) >= 0 ||
                                    (row.voucherCode != null && row.voucherCode.toLowerCase().indexOf(string) >= 0) ||
                                    (row.products.length > 0 &&
                                        (row.products.findIndex(
                                            (p) => p.pimProduct && p.pimProduct.extRef.indexOf(string) >= 0
                                        ) != -1 ||
                                            row.products.findIndex(
                                                (p) =>
                                                    p.pimProduct && p.pimProduct.manufacturerName
                                                        .toLowerCase()
                                                        .indexOf(string) >= 0
                                            ) != -1))
                                );
                            },
                        },

                        {
                            name: "filter",

                            callback(row, payload) {
                                let valid = payload.valid;
                                let type = payload.type;
                                let status = payload.status;
                                let source = payload.source;
                                let voucher = payload.voucher;

                                // reset
                                if (
                                    status == null &&
                                    voucher == null &&
                                    source == null &&
                                    valid == null &&
                                    type == null
                                ) {
                                    return true;
                                }

                                let qualifies = true;

                                // filter valid status
                                if (valid != null) {
                                    if (valid.name == "IS_VALID" && row.validTo == null) {
                                        qualifies = true;
                                    } else if (
                                        valid.name == "IS_INVALID" &&
                                        row.validTo == null
                                    ) {
                                        qualifies = false;
                                    } else {
                                        let currentDate = new Date();
                                        let d = new Date(row.validTo);

                                        qualifies =
                                            valid.name == "IS_VALID"
                                                ? currentDate <= d
                                                : currentDate > d;
                                    }
                                }

                                // filter status
                                if (qualifies && status != null) {
                                    // qaulifies = row.status.name == status.name:
                                    qualifies = row._statusComputed == status.name;
                                }

                                // filter source
                                if (qualifies && source != null) {
                                    qualifies =
                                        source.name == "INTERN"
                                            ? row.site != null && row.parent == null
                                            : row.site == null || row.parent != null;
                                }

                                // filter voucher
                                if (qualifies && voucher != null) {
                                    qualifies =
                                        voucher.name == "VOUCHER_ACTIVE"
                                            ? row.voucherCode != null && row.voucherCode != ""
                                            : row.voucherCode == null;
                                }

                                // filter type
                                if (qualifies && type != null) {
                                    qualifies = row.type.name == type;
                                }

                                return qualifies;
                            },
                        },
                    ],

                    filterable: false,
                    columnsClasses: {
                        actions: "actions",
                        takeOver: "takeOver",
                    },
                },
            },
        };
    },

    computed: {

        offerCategories() {
            return this.$store.getters.getTermsByTaxonomy("APOPOINT_OFFER_CATEGORY");
        },

        settingsOfferCategories() {
            return Object.values(this.offerCategories).filter((v) => ['APOKAT', 'APOTUETE', 'OTHER'].includes(v.name));
        },

        filteredCampaigns() {
            return this.campaigns;
            /*
              if(this.siteId == null) {
                  return this.campaigns;
              } else {
                  return this.campaigns.filter((c) => {
                    if(c.site == null && c.parent == null) {
                        if(c.status.name == 'DRAFT') {
                            // c.status = this.campaignStatus.DRAFT;
                            return true;
                        }
                    }
                    else {
                        return true;
                    }
                  });
              }
              ///    (this.siteId != null && c.site == null && c.status.name == 'PUSBLISHED') || (this.siteId != null && c.site != null && this.siteId == c.site.id));
              */
        },

        isFilterActive() {
            for (let key in this.filters) {
                if (this.filters[key].isActive == true) {
                    return true;
                }
            }

            return false;
        },

        mandatoryFields() {
            return (
                this.newCampaign.type == null ||
                this.newCampaign.description == null ||
                this.newCampaign.description == ""
            );
            // return this.newCampaign.type == null || this.newCampaign.name == null || this.newCampaign.name == '';
        },

        tblColumns() {
            return [
                "type",
                "description",
                "validFrom",
                "validTo",
                "_source",
                "_statusComputed",
                "voucherCode",
                "productCount",
                "takeOver",
                "actions",
            ];
        },

        campaignTypes() {
            return this.$store.getters.getTermsByTaxonomy("APOPOINT_OFFER_TYPE");
        },

        campaignTypesArr() {
            return Object.values(this.campaignTypes);
        },

        campaignStatus() {
            return this.$store.getters.getTermsByTaxonomy("APOPOINT_OFFER_STATUS");
        },

        siteId() {
            return this.givenSiteId != null
                ? this.givenSiteId
                : this.activeUser.site == null
                    ? null
                    : this.activeUser.site.id;
        },
    },

    created() {

        this.fetchData();

        // add translateable displayName to the filter "type" options
        this.filters.filterType.selectOptions = this.campaignTypesArr;
        this.filters.filterType.selectOptions.forEach((f) => {
            f.displayName = this.$t("PIM-CAMPAIGNS-TYPE-" + f.name);
        });

        // these two filters shall only be shown for logged-in pharmacies
        if (this.activeUser.site == null) {
            this.filters.filterSource.show = false;
            this.filters.filterStatus.show = false;
        }
        this.useErpOffers = this.activeUser.site && this.activeUser.site.useErpOffers || false;
    },

    mounted() { },

    watch: {
        "filters.filterSearch.value"(val) {
            this.filters.filterSearch.isActive = !(val == null || val == "");

            if (this.filters.filterSearch.isActive) {
                Event.$emit("vue-tables.pimCampaignsTable.filter::search", val);
            } else {
                Event.$emit("vue-tables.pimCampaignsTable.filter::search", null);
            }
        },
    },

    methods: {

        determineSource(row) {
            if (
                this.siteId != null &&
                row.site == this.siteId &&
                row.parent == null
            ) {
                return "PIM-CAMPAIGNS-SOURCE-OWN_CAMPAIGN";
            } else {
                return "PIM-CAMPAIGNS-SOURCE-HERBA_CAMPAIGN";
            }
        },

        filter() {
            // this.$store.commit('setContentPoolFilter', { type: 'status', value: newVal });

            Event.$emit("vue-tables.pimCampaignsTable.filter::filter", {
                valid: this.filters.filterValid.isActive
                    ? this.filters.filterValid.options.filter((_) => _.selected)[0]
                    : null,
                status: this.filters.filterStatus.isActive
                    ? this.filters.filterStatus.options.filter((_) => _.selected)[0]
                    : null,
                type: this.filters.filterType.isActive
                    ? this.filters.filterType.options.name
                    : null,
                voucher: this.filters.filterVoucher.isActive
                    ? this.filters.filterVoucher.options.filter((_) => _.selected)[0]
                    : null,
                source: this.filters.filterSource.isActive
                    ? this.filters.filterSource.options.filter((_) => _.selected)[0]
                    : null,
            });
        },

        customLabel({ name }) {
            return this.$t("PIM-CAMPAIGNS-TYPE-" + name);
        },



        campaignView(row) {

            this.campaignViewIsLoaded = false;

            let cIndex = this.campaigns.findIndex((c) => c.id == row.id);
            this.$set(this.campaigns[cIndex], "isLoadingPreview", true);

            this.axios
                .get(
                    this.$config.api +
                    "apopointOffer/" +
                    row.id +
                    "?include=apopointOffer.products,apopointOfferProduct.pimProduct,apopointOffer.type,apopointOffer.status,apopointOffer.category,apopointOfferCategory.category,apopointOffer.brands,apopointOfferBrand.brand,apopointOffer.categories,apopointOffer.customerGroups,apopointOfferCustomerGroup.customerGroup"
                )
                .then((res) => {
                    var campaign = res.data;

                    this.modal.title = this.$t(
                        "PIM-CAMPAIGNS-TYPE-" + campaign.type.name
                    );
                    this.modal.class = "preview";
                    this.modal.type = "campaignView";

                    campaign._statusComputed = campaign.status.name;

                    campaign._brands = null;
                    campaign._productCategories = null;
                    campaign._productGroups = null;
                    campaign._customerGroups = null;

                    if (this.siteId != null) {
                        if (campaign.site == null && campaign.status.name == "PUBLISHED") {
                            campaign._statusComputed = this.campaignStatus.DRAFT.name;
                        }
                    }

                    if (campaign.customerGroupIds.length > 0) {
                        this._loadCustomerGroups().then((res) => {
                            let customerGroups = res.data.apopointCustomerGroup;
                            var arr = [];

                            campaign.customerGroupIds.forEach((bid) => {
                                let found = customerGroups.find((b) => b.id == bid);
                                if (found) {
                                    arr.push(found.name);
                                }
                            });

                            campaign._customerGroups = arr.join(", ");
                        });
                    }

                    // load categories in case we've to handle a "discount" or "loyalty_points"
                    if (campaign.type.name == "DISCOUNT" || campaign.type.name == 'LOYALTY_POINTS') {
       
                        (async () => {
                            if (campaign.productGroupIds.length > 0) {
                                await this._loadGroups().then((res) => {
                                    let groups = res.data.apopointProductGroup;
                                    var arr = [];
                                    campaign.productGroupIds.forEach((bid) => {
                                        let found = groups.find((b) => b.id == bid);
                                        if (found) {
                                            arr.push(found.name);
                                        }
                                    });

                                    campaign._productGroups = arr.join(", ");
                                });
                            }

                            if (campaign.brandIds.length > 0) {
                                await this._loadBrands().then((res) => {
                                    let brands = res.data.pimBrand;
                                    var arr = [];

                                    campaign.brandIds.forEach((bid) => {
                                        let found = brands.find((b) => b.id == bid);
                                        if (found) {
                                            arr.push(found.name);
                                        }
                                    });

                                    campaign._brands = arr.join(", ");
                                });
                            }

                            if (campaign.categories.length > 0) {
                                campaign._productCategories = campaign.categories
                                    .map((cat) => cat.category.name)
                                    .join(", ");
                            }

                            this.campaignSelected = campaign;
                            this.$set(this.campaigns[cIndex], "isLoadingPreview", false);
                            this.campaignViewIsLoaded = true;
                            this.showModal = true;
                        })();
                    } else {
                        this.campaignSelected = campaign;
                        this.$set(this.campaigns[cIndex], "isLoadingPreview", false);
                        this.campaignViewIsLoaded = true;
                        this.showModal = true;
                    }
                });
        },

        _loadBrands() {
            return this.axios.get(this.$config.api + "pimBrand");
        },

        _loadGroups() {
            return this.axios.get(
                this.$config.api +
                "apopointProductGroup?include=apopointProductGroup.products&filters[site]=" +
                this.siteId
            );
        },

        _loadCategories() {
            return this.axios.get(
                this.$config.api +
                "pimCategory/tree" +
                (this.pharmacySelected != null && this.pharmacySelected.id
                    ? "?site=" + this.pharmacySelected.id
                    : "")
            );
        },

        _loadCustomerGroups() {
            return this.axios.get(this.$config.api + "apopointCustomerGroup");
        },

        campaignTakeOver(row) {
            let cIndex = this.campaigns.findIndex((c) => c.id == row.id);
            this.$set(this.campaigns[cIndex], "isAccepting", true);

            row.status = this.campaignStatus.PUBLISHED;
            row.site = this.siteId;

            this.axios
                .post(
                    this.$config.api + "apopointOffer/" + row.id + "/copy?include=status",
                    row
                )
                .then((res) => {
                    // this.$set(this.campaigns[cIndex], 'isAccepting', false);
                    this.isRefetching = true;
                    this.fetchData().then((res) => {
                        this.$set(this.campaigns[cIndex], "isAccepting", false);
                    });

                });
        },

        campaignEdit(row) {

            this.$router.push({ name: "pimCampaignsDetail", params: { id: row.id }});

        },

        campaignDelete(id) {
            this.axios
                .delete(this.$config.api + "apopointOffer/" + id)
                .then((res) => {
                    this.fetchData();
                    this.$notify.open({
                        content: "Aktion wurde erfolgreich entfernt!",
                        type: "success",
                    });
                });
        },

        resetFilters() {
            for (let key in this.filters) {
                if (this.filters[key].type != "search") {
                    this.filters[key].isActive = false;
                } else {
                    this.filters.filterSearch.value = null;
                }
            }

            this.filter();
        },

        toggleMarkAll() { },

        fetchData() {

            if (this.isRefetching == false) {
                this.isLoading = true;
            }

            let urlPart = this.siteId != null ? this.siteId + ",null" : null;

            return this.axios
                .get(
                    this.$config.api +
                    "apopointOffer?filters[site]=" +
                    urlPart +
                    "&include=apopointOffer.products,apopointOffer.type,apopointOffer.category,apopointOfferProduct.pimProduct,apopointOffer.status&showMetafields=1"
                )
                .then((res) => {

            
                    const today = new Date();
                    
                    // set operator regarding to prop "isArchive"
                    const operator = this.isArchive ? '<' : '>';

                    // sort by validTo date
                    let items = res.data.apopointOffer.filter(item => {
                        return compareDates(item.validTo, today, operator);
                    });

                    // remove items with ids, which are used as parents
                    const parentIds = new Set(
                        items
                            .filter(item => item.parent !== null)
                            .map(item => item.parent)
                    );
                    items = items.filter(item => !parentIds.has(item.id));
        

                    items.forEach((o) => {

                        o.productCount = o.products.length;
                        o._statusComputed = o.status.name;

                        if (
                            this.siteId != null &&
                            o.site == this.siteId &&
                            o.parent == null
                        ) {
                            o._source = "OWN_CAMPAIGN";
                        } else {
                            o._source = "HERBA_CAMPAIGN";
                        }

                        if (this.siteId != null) {
                            if (o.site == null && o.status.name == "PUBLISHED") {
                                o._statusComputed = this.campaignStatus.DRAFT.name;
                            }
                        }

                    });

                    // site == null und status == PUBLISHED:
                    // -> zeige auf apotheken instanzen mit status DRAFT

                    if (this.siteId != null) {
                        this.campaigns = items.filter((o) => {
                            if (o.site != null && o.site == this.siteId) {
                                return true;
                            } else if (o.site == null && o.status.name != "DRAFT") {
                                return true;
                            }
                        });
                    } else {
                        this.campaigns = items;
                    }

                })
                .then((res) => {

                    if (this.siteId != null) {

                        this.axios
                            .get(this.$config.api + "site/" + this.siteId)
                            .then((res) => {

                                this.site = res.data;

                                if (this.site.offerSettings === null) {
                                    this.site.offerSettings = {
                                        autoApplyHerbaOffers: {}
                                    };

                                    this.settingsOfferCategories.forEach((category) => {
                                        this.site.offerSettings.autoApplyHerbaOffers[category.name] = false;
                                    });
                                }

                                this.isLoading = this.isRefetching = false;

                            });
                    } else {
                        this.isLoading = this.isRefetching = false;
                    }
                });
        },

        closeModal() {
            this.showModal = false;
            this.modal.class = null;
            this.modal.type = null;
            this.modal.title = "";

            this.campaignSelected = null;

        },
    },
};
</script>


<style lang="scss" scoped>
@import "~../../../assets/css/variables.scss";
@import "~pretty-checkbox/src/pretty-checkbox.scss";

.p-default {
    margin: 0;
}

.erpOffersSelector {
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 2px;
    padding: 18px;

    .control-label {
        max-width: 280px;
    }
}

.modal {
    &.preview {
        ::v-deep .modal-card {
            max-width: 640px;
            width: 100%;
            overflow: hidden;

            .modal-card-body {
                position: relative;

                h1 {
                    font-weight: bold;
                    margin-bottom: 24px;
                }

                .section {
                    margin: 0 0 12px 0;
                    padding: 0;

                    label {
                        display: block;
                        text-transform: uppercase;
                        font-size: 10px;
                    }
                }

                ul.pimProducts {
                    margin-left: 16px;
                    list-style: disc;

                    li {
                        padding-left: 6px;
                        padding-bottom: 4px;

                        .subline {
                            font-size: 12px;
                            color: #AAA;
                        }
                    }
                }

                .divider {
                    display: block;
                    margin: 8px 0 20px 0;
                    border-bottom: 2px solid #f5f7f9;
                }
            }
        }
    }
}

::v-deep .VueTables__table {
    td.takeOver {
        text-align: right;
        width: 55px;
        max-width: 55px;
    }

    td.actions {
        text-align: right;
        width: 140px;
        max-width: 140px;

        .button {
            .icon {
                margin: 0 !important;
                font-size: 12px;
            }

            &:not(:first-child) {
                margin-left: 2px;
            }
        }
    }
}

.titlelist {
    font-size: large;
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 6px;
}

.filterBox {
    border: none;
    border-top: 1px solid #eaeaea;
    transition: all 0.3s ease;
    padding: 0;
    margin-bottom: 15px;

    legend {
        margin-left: 20px;
        text-transform: uppercase;
        padding: 0 5px;
        font-size: 13px;
        cursor: pointer;
    }

    .filterWrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        margin: 0 0 10px 0;
    }

    &.active {
        border: 1px solid #eaeaea;
        border-radius: 4px;
        background: #fff;

        >.filterWrapper {
            margin: 6px 10px;
        }
    }
}
</style>
